
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <b-modal
    :id="id"
    modal-class="giga-modal"
    dialog-class="modal-md"
    hide-footer
    :no-close-on-esc="!getModalData.backdropClose"
    :no-close-on-backdrop="!getModalData.backdropClose"
    hide-header
    centered
    lazy
  >

    <h2 class="giga-modal_title">Info</h2>
    <div class="giga-modal_body">
      <p v-html="getModalData.content"></p>
    </div>
    <div class="giga-modal_footer">
      <div class="giga-button">
        <button class="giga-green_button no-icon" data-cy="submit" type="submit" @click="okClick">
          <b-spinner variant="light" small v-if="loader"></b-spinner>
          <span>Se connecter</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {mapGetters} from 'vuex';
import eventBus from '../../shared/event.bus';

export default {
  name: 'ModalNotification',
  props: ['id'],
  methods: {
    okClick() {
      eventBus.$emit('okClick');
    },
    closeClick() {
      eventBus.$emit('closeClick');
    },
  },
  computed: {
    ...mapGetters('notification', ['getModalData'])
  },
};
</script>

